// src/selectors/inbox.js
import { createSelector } from 'reselect'
import Fuse from 'fuse.js'

export const getDataForCurrentFilter = createSelector(
  state => state.data.inbox,
  state => state.inbox.conversationsListFilter,
  state => state.inbox.conversationsListCursor,
  (dataInbox, conversationsListFilter, conversationsListCursor) => {
    if (conversationsListFilter === 'all') {
      return dataInbox || {}
    }
    return conversationsListCursor[conversationsListFilter]?.data || {}
  },
)

export const conversationsInInboxSearch = createSelector(
  // getDataForCurrentFilter,
  state => state.data.inbox,
  state => state.inbox.conversationsListFilter,
  state => state.inbox.conversationsListCursor,
  // ...
  state => state.inbox.conversationsListSearch,
  state => state.inbox.conversationsListUserFilter.filter,
  state => state.inbox.hideStopRequests,
  (
    // inbox,
    dataInbox,
    conversationsListFilter,
    conversationsListCursor,
    listSearch,
    conversationsListUserFilter,
    hideStopRequests,
  ) => {
    const dataInboxAll = dataInbox || {}
    const dataInboxNotAll =
      conversationsListCursor[conversationsListFilter]?.data || {}

    const inbox =
      conversationsListFilter === 'all'
        ? dataInboxAll
        : dataInboxNotAll

    if (Object.keys(inbox || {}).length) {
      const userFilter = conversation => {
        if (
          conversationsListUserFilter === 'all' ||
          conversationsListUserFilter === conversation.contact?.vastuser ||
          (conversationsListUserFilter === 'unassigned' &&
            !conversation.contact.vastuser)
        ) {
          return conversation
        }

        return false
      }

      const hideStopsFilter = conversation => {
        if (hideStopRequests) {
          if (Array.isArray(conversation?.conversation)) {
            const length = conversation.conversation.length
            const lastItem = conversation.conversation[length - 1]

            if (lastItem?.sms?.body?.trim?.()?.toLowerCase?.() === 'stop') {
              return false
            }
          }
        }

        return true
      }

      const sort = (a, b) => {
        if (a.last_interaction === '0001-01-01T00:00:00Z') return -1
        if (b.last_interaction === '0001-01-01T00:00:00Z') return 1
        return new Date(b.last_interaction) - new Date(a.last_interaction)
      }

      if (listSearch.length) {
        const fuse = new Fuse(Object.values(inbox), {
          threshold: 0.3,
          ignoreLocation: true,
          shouldSort: false,
          keys: [
            'contact.first_name',
            'contact.middle_name',
            'contact.last_name',
            'contact.email.address',
            'contact.phones.number',
            'conversation.sms.body',
            'conversation.thread.emails.preview_text',
            'conversation.thread.emails.subject',
          ],
        })

        const search = fuse
          .search(listSearch)
          // .map(result => result.item) // Fuse.js returns an array of objects with an `item` property
          .sort((a, b) => sort(a, b))
          .filter(conversation => userFilter(conversation))
          .filter(conversation => hideStopsFilter(conversation))

        return search
      }

      return Object.values(inbox)
        .sort((a, b) => sort(a, b))
        .filter(conversation => userFilter(conversation))
        .filter(conversation => hideStopsFilter(conversation))
    }

    return []
  },
)

export const itemsInConversationSearch = createSelector(
  state => state.inbox.conversationSearch,
  state =>
    (state.inbox.conversation && state.inbox.conversation.conversation) || [],
  (conversationSearch, conversation) => {
    const conversationFilter = convo => {
      return convo.filter(item => {
        if (conversationSearch[item.type]) {
          if (
            conversationSearch.From &&
            conversationSearch.From > new Date(item.timestamp)
          ) {
            return false
          }

          if (
            conversationSearch.To &&
            conversationSearch.To < new Date(item.timestamp)
          ) {
            return false
          }

          return true
        }
        return false
      })
    }

    if (conversationSearch.search) {
      const fuse = new Fuse(conversation, {
        threshold: 0.5,
        ignoreLocation: true,
        shouldSort: false,
        keys: [
          'sms.body',
          'sms.originator_number',
          'sms.recipient_number',
          'call.recipient_number',
          'call.originator_number',
          'thread.emails.preview_text',
          'thread.emails.subject',
          'thread.emails.from',
          'thread.emails.to.to',
        ],
      })

      return conversationFilter(fuse.search(conversationSearch.search))
    }

    return conversationFilter(conversation)
  },
)
